module.exports = __webpack_public_path__ + "img/ic_preorder1x.af11e27.png";